import { message as showMessage } from 'antd'

/**
 * copyToClipboard - Copy text to clipboard and show success message
 *
 * @param text - Actual text to be copied
 * @param message - Message to be shown to the user as a success message
 */

function copyToClipboard(text: string, message: string) {
	const textField = document.createElement('textarea')
	textField.value = text
	document.body.appendChild(textField)
	textField.select()
	document.execCommand('copy')
	textField.remove()
	showMessage.success(message)
}

export default copyToClipboard
